"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextField;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _reactInputMask = _interopRequireDefault(require("react-input-mask"));
var _enums = require("./enums");
var S = _interopRequireWildcard(require("./styles"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function TextField({
  disabled = false,
  error,
  label,
  labelStyle,
  mask,
  name,
  required = false,
  ...rest
}) {
  const [field, meta] = (0, _formik.useField)(name);
  const errorMessage = meta.touched && meta.error || error;
  const inputMask = _enums.MasksEnum[mask] || mask;
  return /*#__PURE__*/_react.default.createElement(S.Label, {
    $disabled: disabled,
    $error: !!errorMessage,
    htmlFor: name,
    style: labelStyle
  }, label, label && required && ' *', inputMask ? /*#__PURE__*/_react.default.createElement(_reactInputMask.default, _extends({}, field, {
    mask: inputMask
  }), /*#__PURE__*/_react.default.createElement(S.TextField, _extends({}, rest, {
    id: name,
    $error: !!errorMessage
  }))) : /*#__PURE__*/_react.default.createElement(S.TextField, _extends({}, field, rest, {
    id: name,
    $error: !!errorMessage
  })), !!errorMessage && /*#__PURE__*/_react.default.createElement(S.Error, null, errorMessage));
}